/* eslint-disable */
import { forwardRef } from 'react';
import { Box, TextField, Dialog, DialogActions, DialogTitle, Slide } from '@mui/material';
import { Button } from 'antd';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const VerificationModal = ({ open, onClose, onConfirm, details = { accountName: '', accountNo: '', ifsc: '' }, loading = false }) => {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>{'Verify your details?'}</DialogTitle>
            <Box
                sx={{
                    width: '100%',
                    height: 'auto',
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    marginBottom: 2,
                    padding: { xs: '10px', sm: '20px' },
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                }}
            >
                <TextField fullWidth label="Account Name" variant="outlined" disabled value={details?.accountName} />
                <TextField fullWidth label="Account No" variant="outlined" disabled value={details?.accountNo} />
                <TextField
                    fullWidth
                    label="IFSC"
                    variant="outlined"
                    disabled
                    value={details?.ifsc || ''}
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            </Box>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm} type="primary" loading={loading}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VerificationModal;
